import React, { useEffect } from 'react';
import axios from '../../../Helpers/Axiosbase'
import { Card, CardHeader, CardContent, TextField, Button, Switch, FormGroup, FormControlLabel,CardActions } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux'
import useReactRouter from 'use-react-router';
import { makeStyles } from '@material-ui/core/styles';
import { LinearProgress,Snackbar } from '@material-ui/core';
import { useInputChange } from '../../../Helpers/useInputChange'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import * as actions from '../../../Store/Actions'
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: theme.spacing(2),
            width: 250,
        }
    }
}));

export default function AppsManage(props) {
    const [showProgress, setShowProgress] = React.useState(false);

    const reduxAuth = useSelector((state) => state.auth)
    const dispatch = useDispatch();

    const { location, history } = useReactRouter();


    const [input, handleInputChange, handleSwitchChange, setInput] = useInputChange({
        appContextCode: "",
        displayName: "",
        isActive: true,
        displaySequence:""
    });

    const onCancleClickHandler = () =>{
        history.push("/apps")
    }
    const [errorMessage,setErrorMessage]=React.useState({
        open:false,
        errmsg:null,
      });

      const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
      };

    var onSubmitClickHandler = () => {
        setShowProgress(true);
        // console.log(input);
        let url = ""
        url = input._id ? "appUpdate" : "appCreate";
        axios.post(url, { ...input, token: reduxAuth.token, userId: reduxAuth.userId })
            .then(response => {
                history.push('/apps');
            })
            .catch(err => {
                if(typeof err.response!="object")
                {
                  setErrorMessage({
                    open:true,
                    // errmsg:err
                  })
                  console.log(err);
                }
                else 
                {
                if (err.response.status === 403) {
                    setShowProgress(false);
                    dispatch(actions.authSuccess(reduxAuth.userId, reduxAuth.token, reduxAuth.isAdmin, reduxAuth.environments, false));
                } else {
                    setShowProgress(false);
                }
            }
            });
    }

    useEffect(() => {
        // console.log(location.state);
        if (location.state) {
            setInput(location.state);
        }
    }, []);

    const classes = useStyles();

    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;
    return (

        <div>
            <Snackbar
                open={errorMessage.open} autoHideDuration={3000} anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                onClose={handleClose}>
                    <Alert 
                    severity="error"
                    color="error"
                    variant="filled">
                    {errorMessage.errmsg!=null?errorMessage.errmsg:" NetWork Error:Please Check Your Internet Connection"}
                    </Alert>
            </Snackbar>
            {showProgress ? <LinearProgress /> : null}
            <Card>
                <CardHeader title="Manage App" />
                <CardContent >
                    <form className={classes.root}>
                        <div>
                            <TextField name="displayName" id="displayName" label="Display Name" onChange={(event) => handleInputChange(event)} value={input.displayName} />
                            <TextField name="appContextCode" id="appContextCode" label="App Context Code" onChange={(event) => handleInputChange(event)} value={input.appContextCode} />
                            <FormGroup>
                                <FormControlLabel
                                    control={<Switch name="isActive" checked={input.isActive}
                                        onChange={() => handleSwitchChange('isActive')} color="primary" />
                                    }
                                    label="Is Active?" />
                            </FormGroup>
                            <TextField name="displaySequence" id="displaySequence" label="Display Sequence" onChange={(event) => handleInputChange(event)} value={input.displaySequence}/>
                        <CardActions>
                            <Button color="primary" variant="contained" onClick={onSubmitClickHandler}>Submit</Button>
                            <Button color="secondary" variant="contained" onClick={onCancleClickHandler}>Cancle</Button>
                        </CardActions>
                        </div>
                    </form>
                </CardContent>
            </Card>
        </div>
    );
}